import { combineReducers } from 'redux';
import { ActionTypes as BookingActionTypes } from '../../../entities/bookings/actions';

import { IEntityActions } from '../../../data/store';

export const loadingBookings = (state = false, action: any = {} as any) => {
	switch (action.type) {
		case BookingActionTypes.BOOKINGS_GET_BY_PROP_ID_REQUEST:
		case BookingActionTypes.BOOKINGS_GET_BY_OWNER_ID_REQUEST:
			return true;
		case BookingActionTypes.BOOKINGS_GET_BY_PROP_ID_RECEIVE:
		case BookingActionTypes.BOOKINGS_GET_BY_PROP_ID_FAILURE:
		case BookingActionTypes.BOOKINGS_GET_BY_OWNER_ID_RECEIVE:
		case BookingActionTypes.BOOKINGS_GET_BY_OWNER_ID_FAILURE:
			return false;
		default:
			return state;
	}
};

export const loadingProperties = (state = false, action: IEntityActions = {} as any) => {
	switch (action.type) {
		case 'PROPERTY_GET_BY_ID_REQUEST':
			return true;
		case 'PROPERTY_GET_BY_ID_RECEIVE':
		case 'PROPERTY_GET_BY_ID_FAILURE':
			return false;
		default:
			return state;
	}
};

export const cancellingBooking = (state = {} as { [key: string]: boolean }, action: any = {} as any) => {
	switch (action.type) {
		case BookingActionTypes.BOOKINGV2_CANCEL_REQUEST:
			return { ...state, [action.payload.eventId]: true };
		case BookingActionTypes.BOOKINGV2_CANCEL_RECEIVE:
		case BookingActionTypes.BOOKINGV2_CANCEL_FAILURE:
			return { ...state, [action.payload.eventId]: false };
		default:
			return state;
	}
};

interface IBookingViewPageState {
	loadingBookings: ReturnType<typeof loadingBookings>;
	loadingProperties: ReturnType<typeof loadingProperties>;
	cancellingBooking: ReturnType<typeof cancellingBooking>;
}

const bookings = combineReducers<IBookingViewPageState>({
	loadingBookings,
	loadingProperties,
	cancellingBooking
});

export default bookings;
